
    import { Component, Vue, Prop, Watch } from "vue-property-decorator";
    import SelfSchedulingDefaultModal from './SelfSchedulingDefaultModal.vue';
    import { namespace } from "vuex-class";
    import { SelfScheduleDefault, SelfScheduleDefaultShift } from '@/models';

    const profile = namespace("profile");
    const schedule = namespace("schedule");
    @Component({
        components: {
            SelfSchedulingDefaultModal
        },
    })
    export default class SharedModal extends Vue {
        @Prop() currentShift!: SelfScheduleDefaultShift;
        @Prop() calSelectedDates!: any;
        @Prop({required: true}) readonly isSharedPanelOpen!: boolean;
        @Prop() counter: any;

        close() {
            this.$emit("close-modal");
        }

        showSMPModal(){
            this.$emit("showSuccessMesssgPopUp");
        }
    }
